import {
  DEFAULT_LANGUAGE, EMPTY_JOURNEY, isJourneyState, readJson, scopedKey, writeJson,
  type JourneyState, type Language, type StorageAdapter,
} from '@lexicon/core';
import { WEB_KEYS } from '../lib/storage';

/**
 * Journey progress for one language, guarded the way `loadStats` guards
 * stats: anything that is not a state this app could have written is
 * treated as absent and replaced with a fresh run (spec §7).
 */
export async function loadJourney(
  s: StorageAdapter,
  language: Language = DEFAULT_LANGUAGE,
): Promise<JourneyState> {
  const raw = await readJson<unknown>(s, scopedKey(WEB_KEYS.journey, language), null);
  // Spread, never the frozen singleton — callers hand this to setState.
  return isJourneyState(raw) ? { ...raw } : { ...EMPTY_JOURNEY };
}

export async function saveJourney(
  s: StorageAdapter,
  state: JourneyState,
  language: Language = DEFAULT_LANGUAGE,
): Promise<void> {
  await writeJson(s, scopedKey(WEB_KEYS.journey, language), state);
}
